module.exports = __webpack_public_path__ + "img/snow_fall_00014.9b20ef47.png";